export enum GridType {
  SQUARE = 'square',
  TRIANGLE = 'triangle',
}

export enum StripCorner {
  BOTTOM_LEFT = 'BL',
  BOTTOM_RIGHT = 'BR',
  BOTTOM_CENTER = 'BC',
  LEFT_CENTER = 'LC',
  CENTER_CENTER = 'CC',
  RIGHT_CENTER = 'RC',
}

export enum LAYER_NAMES {
  DEFAULT = 'default-layer',
  HEADS = 'head-layer',
  ELEMENTS = 'element-layer',
  EDGES = 'pipe-layer',
  COVERAGE = 'coverage-layer',
  PLANTS = 'plant-layer',
  VALVE_INFO_BOXES = 'valve-info-box-layer',
  // HANDLES = 'handles-layer',
  LEGEND = 'legend-layer',
  SHEETS = 'sheets-layer',
  TRACING = 'tracing-layer',
  OUTLINES = 'outline-layer',
  ELEVATION = 'elevation-pins',
  BASEMAPS = 'basemaps-layer',
  SLEEVES = 'sleeves-layer',
  OVERLAY = 'overlay-layer',
  YARDS = 'yards-layer',
  BEDS = 'beds-layer',
}

export enum ITEMNAMES {
  ARC = 'arc',
  BASEMAP = 'basemap',
  BED = 'bed',
  CLUE = 'head-clue',
  COVERAGE_POINT = 'coverage-point',
  ELEMENT = 'design-element',
  ELEVATION_PIN = 'elevation-pin',
  FITTING = 'fitting',
  GPM_TEXT = 'gpm-text',
  HEAD_CIRCLE = 'head-circle',
  KEY_POINT = 'key-yard-point',
  LEGEND = 'legend',
  MISC_ITEM = 'misc-item',
  ORTHO_DOT = 'ortho-dot',
  OUTLINE = 'yard-outline-path',
  PHOENIX_HEAD = 'phoenix-head',
  PIPE = 'pipe',
  PIPE_TEXT = 'pipe-size-text',
  PLANT_GROUP = 'drip-head-group',
  PRECIP_TEXT = 'precip-text',
  SHEET = 'sheet',
  SLEEVE = 'sleeve',
  SNAP_POINT = 'snap-point',
  SVG_OUTLINE = 'svg-outline',
  SVG_RASTER = 'svg-raster',
  TEXT = 'text-item',
  TMP_HEAD_GROUP = 'tmp-head',
  TMP_HEAD_VERTEX = 'tmp-head-vertex',
  TMP_ICON = 'tmp-icon',
  VALVE = 'valve',
  VALVE_BOX_LOCATION = 'valve-box-location',
  VALVE_TEXT = 'valve-text',
  YARD_INDEX = 'yard-index',
  ZONE_BOX = 'zone-box',
  ZONE_INFO_BOX_GROUP = 'zone-info-box-group',
}

export enum SheetSize {
  SMALL = '24x36',
  LARGE = '36x48',
}
export enum CustomEventType {
  GLOBAL_NOTIFICATION = 'global-notification',
}
export enum HANDLE_POSITION {
  TOP_LEFT = 'topLeft',
  BOTTOM_RIGHT = 'bottomRight',
  TOP_RIGHT = 'topRight',
  BOTTOM_LEFT = 'bottomLeft',
}
